import Footer from '@react/shared/components/Footer';
import Header from '@react/shared/components/Header/Header.container';
import Helmet from 'next/head';
import { useRouter } from 'next/router';
import { StrictMode } from 'react';
import { useEffect } from 'react';
import { SlyPartnerBanner } from 'sly/b2b';
import { TYPEFORM_LINK } from 'sly/b2b/constants';
import PartnersBusinessHeader from 'sly/partners/business/PartnersBusinessHeader';
import PartnersBusinessSectionsOverview from 'sly/partners/business/PartnersBusinessSectionsOverview';
import PartnersBusinessTrustedTopProviders from 'sly/partners/business/PartnersBusinessTrustedTopProviders';
import { pageNames, useEvents } from 'sly/services/events';

// import PartnersQuotes from './PartnersQuotes';

export default function PartnerBusiness() {
  const { events } = useEvents();
  const { query } = useRouter();

  useEffect(() => {
    events.page(pageNames.PartnerBusiness, {});
  }, []);

  return (
    <StrictMode>
      <Helmet>
        <title>Partner Agent Program</title>
        <meta
          name='description'
          content='Create and manage your community profile &amp; inventory that is listed on Seniorly.'
        />
        {query?.prop && <meta name='robots' content='noindex' />}
      </Helmet>
      <header>
        <Header />
      </header>
      <PartnersBusinessHeader />
      <PartnersBusinessTrustedTopProviders />
      <PartnersBusinessSectionsOverview />
      {/* <PartnersQuotes /> awaiting assets*/}
      <SlyPartnerBanner page='B2B partner page' link={TYPEFORM_LINK} />

      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/*@ts-ignore*/}
      <Footer />
    </StrictMode>
  );
}
